export default "__VITE_ASSET__DGPmDDwo__"